import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CalculateIcon from '@mui/icons-material/Calculate';
import { formatCurrency } from '../../utils/formatters';

// Reusable components
const SectionHeader = ({ title }) => (
  <Box display="flex" alignItems="center" mb={2}>
    <CalculateIcon color="primary" sx={{ mr: 1 }} />
    <Typography variant="h6">{title}</Typography>
  </Box>
);

const FinancialRow = ({ label, valueBRL, valueUSD }) => (
  <TableRow>
    <TableCell component="th" scope="row">
      {label}
    </TableCell>
    <TableCell align="right">{formatCurrency(valueBRL, 'BRL')}</TableCell>
    <TableCell align="right">{formatCurrency(valueUSD, 'USD')}</TableCell>
  </TableRow>
);

/**
 * TaxCreditsSection - Displays tax credits information
 * For Account and Order (Third Parties Import) order type
 * @param {Object} props - Component props
 * @param {Object} props.order - Order data
 */
const TaxCreditsSection = ({ order }) => {
  if (!order) return null;

  // Get tax calculation data from order
  const taxCalculation = order.latest_tax_calculation || {};

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <SectionHeader title="TAX CREDITS" />
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Tax Type</TableCell>
                <TableCell align="right">BRL</TableCell>
                <TableCell align="right">USD</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <FinancialRow
                label="IPI"
                valueBRL={taxCalculation.credito_ipi_brl}
                valueUSD={taxCalculation.credito_ipi_usd}
              />
              <FinancialRow
                label="PIS/PASEP"
                valueBRL={taxCalculation.credito_pis_pasep_brl}
                valueUSD={taxCalculation.credito_pis_pasep_usd}
              />
              <FinancialRow
                label="COFINS"
                valueBRL={taxCalculation.credito_cofins_brl}
                valueUSD={taxCalculation.credito_cofins_usd}
              />
              <FinancialRow
                label="ICMS"
                valueBRL={taxCalculation.credito_icms_brl}
                valueUSD={taxCalculation.credito_icms_usd}
              />
              <TableRow sx={{ backgroundColor: 'rgba(0, 0, 0, 0.04)' }}>
                <TableCell component="th" scope="row">
                  <Typography fontWeight="bold">Total Tax Credits</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(taxCalculation.total_tax_credits_brl)}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(taxCalculation.total_tax_credits_usd, 'USD')}</Typography>
                </TableCell>
              </TableRow>
              <TableRow sx={{ backgroundColor: 'rgba(0, 0, 0, 0.02)' }}>
                <TableCell component="th" scope="row">
                  <Typography fontWeight="bold">Custo Total da Importação</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(taxCalculation.custo_total_brl)}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(taxCalculation.custo_total_usd, 'USD')}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default TaxCreditsSection;